import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function applyColorToChildren(element, fillColor, strokeColor) {
  const childrenWithColor = React.Children.map(
    element.props.children,
    (child) => {
      if (React.isValidElement(child)) {
        // Recursively apply color to children elements
        return applyColorToChildren(child, fillColor, strokeColor);
      }
      return child;
    }
  );

  return React.cloneElement(element, {
    ...element.props,
    fill: fillColor,
    stroke: strokeColor,
    children: childrenWithColor,
  });
}

export const SvgToMuiIcon = (svgContent) => {
  return React.forwardRef((props, ref) => {
    let { fill = "currentColor", ...otherProps } = props;

    if (props?.color) {
      fill = props?.color;
    }

    let strokeColor = null;
    if (svgContent.props && svgContent.props.children) {
      const children = Array.isArray(svgContent.props.children)
        ? svgContent.props.children
        : [svgContent.props.children];
      children.forEach((child) => {
        if (child && child.props && child.props.stroke) {
          strokeColor = child.props.stroke;
        }
      });
    }

    const fillColor = strokeColor ? "transparent" : fill;

    const childrenWithColor = React.Children.map(
      svgContent.props.children,
      (child) => {
        if (React.isValidElement(child)) {
          // Recursively apply color to children elements
          return applyColorToChildren(child, fillColor, fill);
        }
        return child;
      }
    );

    const modifiedSvgContent = React.cloneElement(svgContent, {
      ...svgContent.props,
      fill: fillColor,
      stroke: fill,
      children: childrenWithColor,
    });

    return (
      <SvgIcon {...otherProps} viewBox="0 0 32 32" ref={ref}>
        {modifiedSvgContent}
      </SvgIcon>
    );
  });
};
